import { render, staticRenderFns } from "./advance-pension.vue?vue&type=template&id=19cbb88d"
import script from "./advance-pension.vue?vue&type=script&lang=js"
export * from "./advance-pension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports